class CustomCarousel {
    constructor() {
        this.container = [...document.querySelectorAll('.custom-carousel')];
        
        if (this.container.length > 0) 
            this.container.forEach(c => c.addEventListener('click', this.#handleCarouselClick.bind(this)));
    }
    
    #handleCarouselClick (e) {
        if (!e.target.closest('.custom-carousel__btn')) return;

        const target = e.target.closest('.custom-carousel__btn');
        const carousel = target.closest('.custom-carousel').querySelector('.custom-carousel__carousel');

        target.classList.contains('custom-carousel__btn--prev') ? this.#handleCarouselPrev(carousel) : this.#handleCarouselNext(carousel) ;
    }

    #handleCarouselPrev(carousel) {
        const card = carousel.querySelector('.custom-carousel__carousel-item');
        if (!card) return;

        const cardWidth = card.offsetWidth + 16; // width + gap
        carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    }

    #handleCarouselNext(carousel) {
        const card = carousel.querySelector('.custom-carousel__carousel-item');
        if (!card) return;

        const cardWidth = card.offsetWidth + 16; // width + gap
        carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
    }
}

new CustomCarousel();